module.exports = __webpack_public_path__ + "static/media/image1.3445456f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/SketchBook/image1.jpg
// module id = 1073
// module chunks = 0